import { render, staticRenderFns } from "./InvitebyLink.vue?vue&type=template&id=44557edf&"
import script from "./InvitebyLink.vue?vue&type=script&lang=ts&"
export * from "./InvitebyLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports